import React, { useEffect, useState } from "react";
import { useFirebase } from "model/context/firebase.context";
import { COLLECTIONS } from "model/constants";

const LeadsReports = () => {
  const { db } = useFirebase();
  const [leads, setLeads] = useState([]);
  const [filteredLeads, setFilteredLeads] = useState([]);
  const [search, setSearch] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: "name", direction: "asc" });

  useEffect(() => {
    const unsubscribe = db.listen(COLLECTIONS.leads, (data) => {
      const parsed = data
        ? Object.entries(data).map(([id, item]) => ({ id, ...item }))
        : [];
      setLeads(parsed);
    });
    return () => unsubscribe();
  }, [db]);

  useEffect(() => {
    const term = search.toLowerCase();
    const filtered = leads.filter(
      (lead) =>
        lead.name?.toLowerCase().includes(term) ||
        lead.lastName?.toLowerCase().includes(term) ||
        lead.email?.toLowerCase().includes(term)
    );
    setFilteredLeads(filtered);
  }, [search, leads]);

  const sortedLeads = [...filteredLeads].sort((a, b) => {
    const { key, direction } = sortConfig;
    const valA = a[key]?.toString().toLowerCase() || "";
    const valB = b[key]?.toString().toLowerCase() || "";
    if (valA < valB) return direction === "asc" ? -1 : 1;
    if (valA > valB) return direction === "asc" ? 1 : -1;
    return 0;
  });

  const requestSort = (key) => {
    setSortConfig((prev) => ({
      key,
      direction: prev.key === key && prev.direction === "asc" ? "desc" : "asc",
    }));
  };

  const renderBoolIcon = (val) => (
    <span className={`text-xl ${val ? "text-green-500" : "text-red-500"}`}>
      {val ? "✔️" : "❌"}
    </span>
  );

  return (
    <div className="p-4">
      <h1 className="text-xl font-bold mb-4">Leads Report</h1>

      <input
        type="text"
        placeholder="Search leads..."
        className="mb-4 p-2 border rounded w-full max-w-md"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <div className="overflow-auto">
        <table className="min-w-full table-auto border">
          <thead>
            <tr className="bg-gray-100 text-left">
              <th className="p-2 cursor-pointer" onClick={() => requestSort("lastName")}>
                Last Name, Name
              </th>
              <th className="p-2 cursor-pointer" onClick={() => requestSort("city")}>
                City
              </th>
              <th className="p-2 cursor-pointer" onClick={() => requestSort("bidValue")}>
                Bid Value
              </th>
              <th className="p-2 cursor-pointer" onClick={() => requestSort("bidDate")}>
                Bid Date
              </th>
              <th className="p-2 cursor-pointer" onClick={() => requestSort("visitDate")}>
                Visit Date
              </th>
              <th className="p-2 cursor-pointer" onClick={() => requestSort("origin")}>
                Origin
              </th>
              <th className="p-2">Info Confirmed</th>
              <th className="p-2">Interested</th>
              <th className="p-2">Visited</th>
              <th className="p-2">Bid Sent</th>
            </tr>
          </thead>
          <tbody>
            {sortedLeads.map((lead) => (
              <tr key={lead.id} className="border-t hover:bg-gray-50">
                <td className="p-2">{`${lead.lastName || "—"}, ${lead.name || "—"}`}</td>
                <td className="p-2">{lead.city || "—"}</td>
                <td className="p-2">{lead.bidValue || "—"}</td>
                <td className="p-2">{lead.bidDate || "—"}</td>
                <td className="p-2">{lead.visitDate || "—"}</td>
                <td className="p-2">{lead.origin || "—"}</td>
                <td className="p-2 text-center">{renderBoolIcon(lead.isInfoConfirmed)}</td>
                <td className="p-2 text-center">{renderBoolIcon(lead.isInterested)}</td>
                <td className="p-2 text-center">{renderBoolIcon(lead.isVisited)}</td>
                <td className="p-2 text-center">{renderBoolIcon(lead.isbidSent)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {sortedLeads.length === 0 && (
          <p className="mt-4 text-gray-500">No leads found.</p>
        )}
      </div>
    </div>
  );
};

export default LeadsReports;
